import React from 'react';
import { useLocation } from 'react-router-dom';
import BlocContact from '../components/BlocContact';
import Revele from '../components/Revele';
import { useLangue } from '../i18n/LangueContext';

const SUJETS = {
  acces: 'sujetAcces',
  partenaire: 'sujetPartenaire',
  contact: 'sujetContact'
};

export const PageDemande = ({ cle, type }) => {
  const { t } = useLangue();
  const location = useLocation();
  const besoin = (location.state && location.state.besoin) || '';
  const bloc = t[cle];
  const sujet = besoin ? t.contact.sujetBesoin : t.contact[SUJETS[type] || 'sujetContact'];

  return (
    <main id="principal">
      <section>
        <div className="conteneur">
          <Revele className="tete-section">
            <h1 style={{ fontSize: 'clamp(2rem,4vw,3rem)', marginBottom: '1.15rem' }}>{bloc.titre}</h1>
            <p className="chapeau">{bloc.chapeau}</p>
          </Revele>
          <div className="form-page">
            <BlocContact sujet={sujet} corps={besoin} />
            <aside className="recap">
              <div className="recap-tete">{besoin ? t.besoin.recapTete : t.contact.asideTete}</div>
              {besoin ? (
                <div className="recap-corps">
                  {besoin.split('\n').map((l, i) => (
                    <div key={i}>{l}</div>
                  ))}
                </div>
              ) : null}
              <div className="recap-reste" style={{ paddingTop: besoin ? 0 : '1.2rem' }}>{bloc.encadre}</div>
            </aside>
          </div>
        </div>
      </section>
    </main>
  );
};

const MOTIF_EMAIL = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
const EST_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const avecLiens = (texte) =>
  texte.split(MOTIF_EMAIL).map((morceau, i) =>
    EST_EMAIL.test(morceau) ? (
      <a key={i} href={`mailto:${morceau}`} className="lien-oxyde">{morceau}</a>
    ) : (
      <React.Fragment key={i}>{morceau}</React.Fragment>
    )
  );

export const PageLegale = ({ cle }) => {
  const { t } = useLangue();
  const blocs =
    cle === 'mentions'
      ? t.legales.mentionsBlocs
      : cle === 'confidentialite'
      ? t.legales.confidentialiteBlocs
      : cle === 'cookies'
      ? t.legales.cookiesBlocs
      : cle === 'conditions'
      ? t.legales.conditionsBlocs
      : null;

  return (
    <main id="principal">
      <section>
        <div className="conteneur">
          <div className="texte-legal">
            <h1 style={{ fontSize: 'clamp(2rem,4vw,3rem)', marginBottom: '1.15rem' }}>{t.legales[cle]}</h1>
            {blocs ? (
              blocs.map((b) => (
                <Revele key={b.titre} className="bloc-legal">
                  {b.niveau === 2 ? <h2>{b.titre}</h2> : <h3>{b.titre}</h3>}
                  {b.paragraphes.map((p, i) => (
                    <p key={i}>{avecLiens(p)}</p>
                  ))}
                  {b.adresse && (
                    <div className="bloc-adresse">
                      {b.adresse.map((l, i) => (
                        <span key={i}>{avecLiens(l)}</span>
                      ))}
                    </div>
                  )}
                  {b.liste && (
                    <ul className="liste-fine liste-legale">
                      {b.liste.map((l, i) =>
                        typeof l === 'string' ? (
                          <li key={l}>{l}</li>
                        ) : (
                          <li key={`${l.libelle}${i}`}>
                            {l.libelle ? <strong>{l.libelle} </strong> : null}
                            {avecLiens(l.texte)}
                          </li>
                        )
                      )}
                    </ul>
                  )}
                  {b.apres &&
                    b.apres.map((p, i) => (
                      <p key={`ap${i}`} style={{ marginTop: '1.2rem' }}>{avecLiens(p)}</p>
                    ))}
                </Revele>
              ))
            ) : (
              <p className="chapeau">{t.legales.texte}</p>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

export default PageDemande;
